<template>
    <div class="header">
        <input
            :key="`${navbarInputKey}`"
            type="checkbox"
            class="hamburger_icon-input"
            id="navbar-open"
            :checked="editing ? true : undefined"
        />
        <label for="navbar-open" href="#" class="mobile-menu last-child">
            <HamburgerIcon
                alt="mobile menu"
            />
        </label>
        <!-- MOBILE MENU -->
        <div class="mobile_menu">
            <label for="navbar-open" aria-label="Close menu">
                <div class="mobile_menu-open_label"></div>
            </label>
            <div class="mobile_menu-container">
                <div ref="closeContainer" class="mobile_menu-close_container">
                    <label for="navbar-open">
                        <CloseIcon
                            alt="Cart icon"
                            class="mobile_menu-close_container-close_img"
                        />
                    </label>
                </div>
        <div v-if="isDealer" class="mobile_menu-cart-summary">
            <Link as="div" :preserve-state="false" :href="route('cart.show')" class="cart-summary-header bg-rothcoCharcoal" :onStart="() => close()">
                <div class="headline-xs text-rothcoWhite">
                    View Cart
                </div>
                <!-- <div class="flex justify-center justify-self-end items-center col-span-1 py-2.5 bg-rothcoRed rounded-tr-[3px] w-9">
                    <div class="flex">
                        <img loading="lazy" src="@icons/carrets-white.svg"  alt="" loading="lazy"/>
                    </div>
                </div> -->
                <!-- once styleguide has been merged use this button, above is for QA purposes -->
                <button class="bg-rothcoRed">
                    <CarretsWhite alt="" />
                </button>
            </Link>
            <div class="cart-summary-body">
                <div class="line-item-total">
                    <div class="paragraph-default">
                       {{ b2bInfo.totalStyles }} Styles {{ b2bInfo.totalSkus }} SKUs {{ b2bInfo.totalQuantity }} Qty
                    </div>
                    <div class="title-s">
                        ${{ b2bInfo.totalPrice.toFixed(2) }}
                    </div>
                </div>

                <div class="mobile-b2b-menu">
                    <Link :preserve-state="false" :onStart="() => close()" :href="route('index.quickOrdering')" class="b2b-menu-link">
                        <QuickOrderingIcon alt="" role="presentation" />
                        <span>Quick Order</span>
                    </Link>
                    <Link :preserve-state="false" :onStart="() => close()"  :href="route('checkout.express')" class="b2b-menu-link">
                        <CartMobile alt="" role="presentation" />
                        <span>Checkout</span>
                    </Link>
                </div>
            </div>
        </div>
                <div class="mobile_menu-items_container">
                    <ul
                        v-for="(menuItem, index) of menu"
                        :key="`menu-${index}`"
                        :class="`menu-item ${slugify(menuItem.text)}`"
                    >
                        <input
                            @input="setViewingMenu(menuItem, null)"
                            type="checkbox"
                            :id="`checkbox-${slugify(menuItem.text)}`"
                            :class="`menu-item-checkbox ${slugify(menuItem.text)}-checkbox`"
                            :checked="
                                editing &&
                                editingSubMenu == slugify(menuItem.text)
                                    ? true
                                    : undefined
                            "
                        />
                        <component
                            :is="!hasChildren(menuItem, 1) && !menuItem.useCmsMegaMenu ? Link : 'label'"
                            as="label"
                            :for="`checkbox-${slugify(menuItem.text)}`"
                            :class="{
                                'mobile_menu-title headline-s': true,
                                'sale-nav-item': menuItem.sales,
                            }"
                            :href="getLinkUrl(menuItem)"
                            :onStart="() => close(menuItem)"
                        >
                            {{ menuItem.text }}
                            <ArrowBlack
                                v-if="
                                    hasChildren(menuItem, 1) ||
                                    menuItem.useCmsMegaMenu
                                "
                                alt="black arrow"
                            />
                    </component>
                        <ul
                            v-if="
                                hasChildren(menuItem, 1) ||
                                menuItem.useCmsMegaMenu
                            "
                            :class="`mobile_menu-submenu ${slugify(menuItem.text)}`"
                        >
                            <li :class="`mobile_menu-submenu_close`">
                                <label
                                    :for="`checkbox-${slugify(menuItem.text)}`"
                                    class="mobile_menu-back_link"
                                    aria-label="Return to main menu"
                                >
                                    <BackRedIconArrow
                                        alt="red arrow"
                                    />
                                    <span class="text-rothcoRed clickable">All</span>
                                </label>
                                <label
                                    for="navbar-open"
                                    aria-label="Close Menu"
                                >
                                    <label
                                        :for="`menu-item-${slugify(menuItem.text)}`"
                                    ></label>
                                    <CloseIcon
                                        :id="`menu-close-${slugify(menuItem.text)}`"
                                        alt="close icon"
                                        class="mobile_menu-close_container-close_img"
                                    />
                                </label>
                            </li>
                            <div class="mobile_menu-submenu_subtitle_container">
                                <div
                                    class="mobile_menu-submenu_third_level_subtitle"
                                >
                                    <Link
                                        class="mobile_menu-submenu_title headline-s"
                                        :href="getLinkUrl(menuItem)"
                                        :onStart="()=>close()"
                                    >
                                        {{ menuItem.text }}
                                    </Link>
                                    <label
                                        v-if="menuItem.shopAllLink"
                                        :for="`${slugify(menuItem.text)}`"
                                        class="mobile_menu-submenu_link"
                                        aria-label="Shop all"
                                    >
                                        <Link
                                            v-if="menuItem.shopAllLink"
                                            :href="menuItem.shopAllLink"
                                            :preserveState="false"
                                            :onStart="() => close(menuItem)"
                                            >Shop All</Link
                                        >
                                        <RedArrows
                                            alt="red arrow"
                                        />
                                    </label>
                                </div>

                                <ul class="mobile_menu-submenu_items_container">
                                    <div v-if="hasChildren(menuItem, 1)">
                                        <li
                                            :class="{
                                                no_border: secondaryIndex == 0,
                                                'menu-item': hasChildren(
                                                    secondaryItem,
                                                    2
                                                ),
                                                [`${slugify(secondaryItem.text)}`]:
                                                    hasChildren(
                                                        secondaryItem,
                                                        2
                                                    )
                                            }"
                                            v-for="(
                                                secondaryItem, secondaryIndex
                                            ) of menuItem.secondary"
                                            :key="`menuItem-secondary-${secondaryIndex}`"
                                        >
                                            <Link
                                                :href="getLinkUrl(secondaryItem)"
                                                :onStart="() => close(menuItem)"
                                                v-if="
                                                    !hasChildren(
                                                        secondaryItem,
                                                        2
                                                    )
                                                "
                                            >
                                                {{ secondaryItem.text }}
                                            </Link>
                                            <div v-else style="width: 100%">
                                                <input
                                                    @input="
                                                        setViewingMenu(
                                                            secondaryItem,
                                                            menuItem
                                                        )
                                                    "
                                                    type="checkbox"
                                                    :id="`checkbox-${slugify(secondaryItem.text)}`"
                                                    :class="`menu-item-checkbox ${slugify(secondaryItem.text)}-checkbox`"
                                                    :checked="
                                                        editing
                                                            ? editingSubMenu ==
                                                              slugify(
                                                                  secondaryItem.text
                                                              )
                                                            : undefined
                                                    "
                                                />
                                                <label
                                                    :for="`checkbox-${slugify(secondaryItem.text)}`"
                                                    style="display: flex; justify-content: space-between"
                                                >
                                                    {{ secondaryItem.text }}
                                                    <span>&nbsp;</span>
                                                    <ArrowBlack
                                                        alt="black arrow"
                                                    />
                                                </label>
                                                <ul
                                                    :class="`mobile_menu-submenu mobile_menu-submenu-third_level ${slugify(secondaryItem.text)}`"
                                                >
                                                    <li
                                                        :class="`mobile_menu-submenu_close mobile_menu-submenu_close-third_level`"
                                                    >
                                                        <label
                                                            :for="`checkbox-${slugify(secondaryItem.text)}`"
                                                            class="mobile_menu-back_link"
                                                            aria-label="Return to main menu"
                                                        >
                                                            <BackRedIconArrow
                                                                alt="red arrow"
                                                            />
                                                            <span class="text-rothcoRed clickable">{{
                                                                menuItem.text
                                                            }}</span>
                                                        </label>
                                                        <label
                                                            for="navbar-open"
                                                            aria-label="Close Menu"
                                                        >
                                                            <label
                                                                :for="`menu-item-${slugify(secondaryItem.text)}`"
                                                            ></label>
                                                            <CloseIcon
                                                                :id="`menu-close-${slugify(secondaryItem.text)}`"
                                                                alt="close icon"
                                                                class="mobile_menu-close_container-close_img"
                                                            />
                                                        </label>
                                                    </li>
                                                    <div
                                                        class="mobile_menu-submenu_subtitle_container"
                                                    >
                                                        <div
                                                            class="mobile_menu-submenu_third_level_subtitle"
                                                        >
                                                            <Link
                                                                class="mobile_menu-submenu_title headline-s"
                                                                :href="getLinkUrl(secondaryItem)"
                                                                :onStart="()=>close()"
                                                                style="font-weight: 800"
                                                            >
                                                                {{
                                                                    secondaryItem.text
                                                                }}
                                                            </Link>
                                                            <label
                                                                :for="`menu-item-${slugify(secondaryItem.text)}`"
                                                                class="mobile_menu-submenu_link"
                                                                aria-label="Shop all"
                                                               
                                                            >
                                                                <Link :onStart="() => close(secondaryItem)" class="text-rothcoRed" :href="secondaryItem.shopAllLink">Shop All</Link>
                                                                <RedArrows
                                                                    alt="red arrow"
                                                                />
                                                            </label>
                                                        </div>
                                                        <ul
                                                            class="mobile_menu-submenu_items_container"
                                                        >
                                                            <Link
                                                                as="li"
                                                                :onStart="() => close(secondaryItem)"
                                                                :href="getLinkUrl(tertiaryItem)"
                                                                :class="{
                                                                    no_border:
                                                                        tertiaryIndex ===
                                                                        0
                                                                }"
                                                                v-for="(
                                                                    tertiaryItem,
                                                                    tertiaryIndex
                                                                ) of secondaryItem.tertiary"
                                                                :key="`menuItem-tertiary-${tertiaryIndex}`"
                                                            >
                                                                {{
                                                                    tertiaryItem.text
                                                                }}
                                                            </Link>
                                                        </ul>
                                                        <div v-if="bannerData.image" class="mobile_menu-submenu_image">
                                                            <img
                                                                :src="optimize(bannerData.image)"
                                                                alt="menu image"
                                                            />
                                                            <div class="mobile_menu-submenu_image-container">
                                                                <p class="headline-xs">{{ bannerData.title }}</p>
                                                                <Link v-if="bannerData?.cta?.label" class="dark" aria-label="Shop the collaboration" :href="getLinkUrl({url: bannerData?.cta})" :onStart="() => close(menuItem)">
                                                                    {{ bannerData?.cta?.label }}
                                                                    <CarretsWhite alt="white arrow" class="carrets-white"/>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        <Cms
                                                            v-if="menuViewing != null && secondaryItem.text == menuViewing.text"
                                                            v-model="bannerData"
                                                            :readable-fields="['slug', 'image', 'cta', 'title', 'cascade']"
                                                            model="mega-menu-header"
                                                            :search-params="searchParams"
                                                            driver="builder"
                                                            is-section
                                                            :components="
                                                                registeredComponents
                                                            "
                                                           
                                                        />
                                                    </div>
                                                </ul>
                                            </div>
                                        </li>
                                    </div>
                                        <Link
                                            as="div"
                                            :href="getLinkUrl(link)"
                                            v-for="link of mainSectionLinks(menuItem)"
                                            :key="`menuItem-mainSection-${link.text}`"
                                            :class="{
                                                'mobile_menu-submenu_one-featured': true,
                                                'mobile_menu-submenu_one': true,
                                                no_border: true
                                            }"
                                            :onStart="() => close(menuItem)"
                                            >
                                            <p>{{ getMainLinkText(link) }}</p>
                                            <p
                                                v-if="link.tag != null"
                                                class="mobile_menu-submenu_one-featured_menu_tag"
                                                >{{ getTagValue(link) }}</p
                                            >
                                        </Link>
                                    <div
                                        v-if="hasPallete(menuItem)"
                                        class="mobile_menu-submenu_grid"
                                    >
                                        <Link as="p" v-bind="getPallete(menuItem, 'military')" class="headline-xs">Military</Link>
                                        <Link as="p"  v-bind="getPallete(menuItem, 'tactical')" class="headline-xs">Tactical</Link>
                                        <Link as="p" v-bind="getPallete(menuItem, 'work')"  class="headline-xs">Work</Link>
                                        <Link as="p"  v-bind="getPallete(menuItem, 'outdoor')" class="headline-xs">Outdoor</Link>
                                    </div>
                                    <div v-if="bannerData.image" class="mobile_menu-submenu_image">
                                        <img
                                            :src="optimize(bannerData.image)"
                                            alt="menu image"
                                        />
                                        <div class="mobile_menu-submenu_image-container">
                                            <p class="headline-xs">{{ bannerData.title }}</p>
                                            <Link v-if="bannerData?.cta?.label" class="dark" aria-label="Shop the collaboration" :href="getLinkUrl({url: bannerData?.cta})" :onStart="() => close(menuItem)">
                                                {{ bannerData?.cta?.label }}
                                                <CarretsWhite alt="white arrow" class="carrets-white"/>
                                            </Link>
                                        </div>
                                    </div>
                                    <Cms
                                        v-if="menuViewing != null && menuItem.text == menuViewing.text"
                                        
                                        v-model="bannerData"
                                        :readable-fields="['slug', 'image', 'cta', 'title', 'cascade']"
                                        model="mega-menu-header"
                                        :search-params="searchParams"
                                        driver="builder"
                                        is-section
                                        :components="registeredComponents"
                                       
                                    />
                                </ul>
                            </div>
                        </ul>
                    </ul>
                    <div class="mobile_menu-additional_menu">
                        <div
                            v-if="isLoggedIn"
                            class="mobile_menu-additional_menu-item"
                        >
                            <DealerIcon
                                alt="phone icon"
                            />
                            <Link :onStart="() => close()" :href="route('account.show')">{{
                                isDealer ? "Manage Account" : "My Account"
                            }}</Link>
                            |
                            <Link :onStart="()=> close()" :href="route('web.logout')">Log Out</Link>
                        </div>
                        <Link
                            :onStart="() => close()"
                            :href="route('customer-service.index')"
                            class="mobile_menu-additional_menu-item"
                        >
                            <SupportIcon
                                alt="support-icon"
                            />
                            <p>Support</p>
                     </Link>
                        <Link
                            v-if="!isLoggedIn || !isDealer"
                            :onStart="() => close()"
                            :href="route('index.becomeADealer')"
                            class="mobile_menu-additional_menu-item"
                        >
                            <DealerIcon
                                alt="dealer icon"
                            />
                            <p>Become a Dealer</p>
                        </Link>
                        <Link
                            v-if="!isLoggedIn || !isDealer"
                            :onStart="() => close()"
                            :href="route('retail.locator.search')"
                            class="mobile_menu-additional_menu-item"
                        >
                            <RetailIcon
                                alt="retail icon"
                            />
                            <p>Retail Locator</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, provide, inject } from "vue";
    import { isEditing, isPreviewing } from "@builder.io/sdk-vue";
    import { type Node } from "@interfaces/Node.ts";
    import Cms from "@/components/Cms.vue";
    // import { route } from "ziggy-js";
    import { Link } from "@inertiajs/vue3";
    import { registeredComponents } from "@root/mega-menu-init";
    import { slugify } from "@/helpers/composables/slugify";
    import useImageOptimization from "@/helpers/composables/useImageOptimization";
    import CartMobile from "@icons/cart_red_mobile.svg";
    import QuickOrderingIcon from "@icons/quick_order_mob.svg";
    import CarretsWhite from "@icons/carrets-white.svg";
    import ArrowBlack from "@icons/arrow-black-right.svg";
    import BackRedIconArrow from "@icons/back-red-icon-arrow.svg";
    import CloseIcon from "@icons/closeIcon.svg";
    import RedArrows from "@icons/red-arrows.svg";
    import DealerIcon from "@icons/dealer icon.svg";
    import SupportIcon from "@icons/support-icon.svg";
    import RetailIcon from "@icons/retail-icon.svg";
    import HamburgerIcon from "@icons/hamburger-icon.svg";
    const navbarInputKey = ref(0);
    let { optimize } = useImageOptimization();
    let menu = defineModel({
        type: Array,
        default() {
            return [];
        }
    });
    let route = inject("route");
    let bannerData = ref({
        title: "",
        image: "",
        slug: "",
        cta: {

        }
    })

    let menuViewing = ref(null);
    let closeContainer = ref();
    function setViewingMenu(menuItem, parent) {
        menuViewing.value = {
            ...menuItem,
            parent: parent ? parent : null
        };
    }

    type B2BInfo = {
        totalQuantity: number;
        totalStyles: number,
        totalSkus: number;
        totalPrice: number;
    };
    let props = defineProps({
        b2bInfo: {
            type: Object as PropType<B2BInfo>,
            default() {
                return {};
            }
        },
        isLoggedIn: {
            type: Boolean,
            default: false
        },
        isDealer: {
            type: Boolean,
            default: false
        }
    });

    let editing = computed(() => {
        if (typeof window === "undefined") {
            return false;
        }
        return (
            (isEditing() || isPreviewing()) &&
            window.location.href.includes(`/banner`)
        );
    });

    let editingSubMenu = computed(() => {
        if (typeof window === "undefined" || !editing.value) {
            return undefined;
        }
        //make the href ref cut out any query params and split the url by '/'
        let url = new URL(window.location.href);
        let href = url.pathname.split("/");
        return href[href.length - 1];
    });

    function isEditingSubMenu(item: Node) {
        return false;
        let url = new URL(window.location.href);
        let href = url.pathname.split("/");
        return href.includes(slugify(item.text));
    }

    function hasChildren(item: Node, level: number) {
        if (level == 1) {
            return item.secondary && item.secondary.length > 0;
        }
        if (level == 2) {
            return item.tertiary && item.tertiary.length > 0;
        }
        return false;
    }

    function hasMainLinks(item: Node) {
        return item.mainSection?.links?.length > 0;
    }

    function hasPallete(item: Node) {
        return item.mainSection?.showPallete;
    }

    function getMainLinkText(link) {
        return link.text;
    }

    function getTagValue(link) {
        return link.tag?.value.data.tagname;
    }

    function getBannerUrl(item: Node, parent?: Node) {
        let menusToViewFrom = [];
        if (parent) {
            menusToViewFrom.push(slugify(parent.text));
        }
        menusToViewFrom.push(slugify(item.text));

        return {
            'data.slug.$in': menusToViewFrom
        }
    }


    let searchParams = computed(() => {
        if(!menuViewing.value) {
            return {};
        }
        let menusToViewFrom = [];
        if (menuViewing.value.parent) {
            menusToViewFrom.push(slugify(menuViewing.value.parent.text));
        }
        menusToViewFrom.push(slugify(menuViewing.value.text));
        return {
            'data.slug.$in': menusToViewFrom
        }
    });

    function close(menuItem = null) {
        if (menuItem == null) {
            closeContainer.value?.click?.();
            menuViewing.value = null;
            navbarInputKey.value++;
            return;
        }
        let closeIcon = document.getElementById(`menu-close-${slugify(menuItem.text)}`);
        closeIcon?.click?.();
        menuViewing.value = null;
        navbarInputKey.value++;
    }
    provide('closeMobileMenu', close);

    function getLinkUrl({ url, urlParams}){
        let newUrl = "/404";
        if(typeof url === 'string'){
            newUrl = url;
            try{
                return route(newUrl, urlParams);
            }catch(e){
                return newUrl;
            }
        }
        else{
            if (url?.urlType === "general") {
                newUrl = url?.generalUrl?.value?.data;
                if (newUrl?.alias) {
                    newUrl = route(newUrl.alias, newUrl.params);
                }else{
                    newUrl = "/404";
                }
            } else if (url?.urlType === "product") {
                newUrl = "/404";
                if(url?.productUrl?.productType === "item") {
                    newUrl = route("productDetail.show", { seo_name: url?.productUrl?.seoName });
                    
                }else if(url?.productUrl?.productType === "category") {
                    newUrl = route(`category.${url?.productUrl?.shopAll ? 'shop-all' : 'show'}`, { seo_name: url?.productUrl?.seoName });
                }else if(url?.productUrl?.productType === "collection") {
                    newUrl = route("productListing.collection", { collection: url?.productUrl?.seoName });
                }
            } else {
                newUrl = url?.externalUrl ?? "/404";
            }
        }
        return newUrl;
    }
  

    function getPallete(item: Node, type: string) {
        let palleteBinding =  item.palleteLinks?.[type] ?? {};
        return {
            ...palleteBinding,
            onStart: () => close(item)
        }
    }

    function mainSectionLinks(item: Node) {
        return item.mainSection?.links ?? [];
    }
</script>
